import { IndexRoute, Route, Redirect } from 'react-router';

import WixSDK from 'shared/utils/wix-sdk';
import deviceTypes from 'shared/constants/device-types';

import NotFoundView from 'shared/views/not-found-view/not-found-view';

import DesktopLayout from 'widget/layouts/desktop/desktop';
import MobileLayout from 'widget/layouts/mobile/mobile';
import DesktopViewsSwitcher from 'widget/views/desktop/desktop-views-switcher';
import MobileView from 'widget/views/mobile/mobile';


const MOBILE_ROUTE_PREFIX = '/mobile';

function getUrlDeviceType(location) {
  return _.startsWith(location.pathname, MOBILE_ROUTE_PREFIX) ?
    deviceTypes.MOBILE :
    deviceTypes.DESKTOP;
}

function requireRedirectToMobile(nextState, replace) {
  if (
    WixSDK.Utils.getDeviceType() === deviceTypes.MOBILE &&
    getUrlDeviceType(nextState.location) !== deviceTypes.MOBILE
  ) {
    replace('/mobile');
  }
}

function onEnterMobile() {
  // TODO: set full width
}

export default (
  <Route path="/">
    <Route onEnter={requireRedirectToMobile}
           component={DesktopLayout}>
      <IndexRoute component={DesktopViewsSwitcher} />
    </Route>
    <Route path={MOBILE_ROUTE_PREFIX}
           onEnter={onEnterMobile}
           component={MobileLayout}>
      <IndexRoute component={MobileView} />
    </Route>
    <Route path="/404"
           component={NotFoundView} />
    <Redirect from="*"
              to="/404" />
  </Route>
);



// WEBPACK FOOTER //
// ./src/widget/routes/index.js